import { useGetSettingsQuery, useGetUISettingsQuery } from 'store/services/core/settings';
export const DEFAULT_PAGE_SIZE = 10;

const UI_SETTING_KEY = 'pageSize';

type UseDefaultPageSize = (defaultValue?: number) => number;

export const useDefaultPageSize: UseDefaultPageSize = (defaultValue = DEFAULT_PAGE_SIZE) => {
  const { data: settings } = useGetSettingsQuery();
  const { data: uiSettings } = useGetUISettingsQuery();

  const userPageSize = uiSettings?.uiSettings.find((s) => s.key === UI_SETTING_KEY);
  if (userPageSize) {
    const parsed = parseInt(userPageSize.value, 10);
    if (parsed > 0) return parsed;
  }

  if (settings?.pageRowCount && settings.pageRowCount > 0) return settings.pageRowCount;
  return defaultValue;
};
